import userRepository from "@/data/userRepository";
import { globalState } from '@/globalState';

const securityService = {
  login,
  logout
};

export default securityService;

function login(password: string) {
  return userRepository.login(password).then(res => {
    globalState.isLoggedIn = true;
  });
}

function logout() {
  return userRepository.logout();
}
